export default __webpack_public_path__ + "static/media/takeawayqr.4a94538d.svg";